type Picture = {
  cropped: string;
  original: string;
};
interface Childcare {
  childcareAdditionalServices;
  childcareAgeExperience;
  babySitter;
  picture: Picture;
  willingToDriveChildren: boolean | null;
  workWithTwins: boolean | null;
  yearsOfExperience: number | null;
}
interface ProfileInterface {
  badges: string[];
  childcare: Childcare;
  createdAt: string;
  firstName: string;
  lastName: string;
  lastAuthenticationAt: string;
  updatedAt: string;
}

export default class Profile implements ProfileInterface {
  badges: string[];

  childcare: Childcare;

  createdAt: string;

  firstName: string;

  lastName: string;

  lastAuthenticationAt: string;

  updatedAt: string;

  constructor({ badges, childcare, createdAt, firstName, lastName, lastAuthenticationAt, updatedAt }: ProfileInterface) {
    this.badges = badges;
    this.childcare = childcare;
    this.createdAt = createdAt;
    this.firstName = firstName;
    this.lastName = lastName;
    this.lastAuthenticationAt = lastAuthenticationAt;
    this.updatedAt = updatedAt;
  }

  hasSitterProfile(): boolean {
    return this.childcare?.babySitter !== undefined;
  }
}
